import React from "react"
import "./plans.css"

export const SUPPORT_NUMBER = "+212 676263023"
const WHATSAPP_LINK = "https://wa.me/212676263023"

const TAGLINE_COPY = {
  fr: "Simple, transparente, pensée pour les coopératives",
  ar: "بسيطة وشفافة ومصممة للتعاونيات",
  en: "Simple, Transparent, Built for Cooperatives",
}

const MODAL_COPY = {
  fr: {
    title: "Contactez notre équipe",
    message: (planName) => `Merci pour votre intérêt pour ${planName}. Contactez notre équipe via WhatsApp ou téléphone pour activer votre abonnement et recevoir un accompagnement personnalisé.`,
    whatsapp: "WhatsApp",
    call: "Appeler",
    close: "Fermer",
  },
  ar: {
    title: "تواصل مع فريق الدعم",
    message: (planName) => `شكراً لاختيارك ${planName}. تواصل معنا عبر واتساب أو الهاتف لتفعيل الاشتراك والحصول على مرافقة مخصصة.`,
    whatsapp: "واتساب",
    call: "اتصال",
    close: "إغلاق",
  },
  en: {
    title: "Talk to our support team",
    message: (planName) => `Thanks for choosing ${planName}. Reach us on WhatsApp or by phone to activate your plan and get personalized onboarding.`,
    whatsapp: "WhatsApp",
    call: "Call",
    close: "Close",
  },
}

const PlanContactModal = ({ plan, language = 'fr', onClose }) => {
  if (!plan) return null
  const langKey = ['fr', 'ar', 'en'].includes(language) ? language : 'fr'
  const copy = MODAL_COPY[langKey]
  const sanitizedNumber = SUPPORT_NUMBER.replace(/\s+/g, '')

  return (
    <div className="plan-modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="plan-modal" onClick={(e) => e.stopPropagation()}>
        <button className="plan-modal-close" onClick={onClose} aria-label={copy.close}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        
        <div className="plan-modal-header">
          <div className="plan-modal-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
          </div>
          <h3 className="plan-modal-title">{plan.name}</h3>
          <p className="plan-modal-subtitle">{copy.title}</p>
        </div>

        <div className="plan-modal-body">
          <p className="plan-modal-message">{copy.message(plan.name)}</p>
          
          <div className="plan-modal-contact-card">
            <div className="plan-modal-contact-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </div>
            <div className="plan-modal-contact-info">
              <span className="plan-modal-contact-label">{langKey === 'fr' ? 'Contactez-nous' : langKey === 'ar' ? 'اتصل بنا' : 'Contact us'}</span>
              <span className="plan-modal-contact-number">{SUPPORT_NUMBER}</span>
            </div>
          </div>
        </div>

        <div className="plan-modal-actions">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className="plan-modal-btn plan-modal-btn-whatsapp"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            {copy.whatsapp}
          </a>
          <a
            href={`tel:${sanitizedNumber}`}
            className="plan-modal-btn plan-modal-btn-call"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
            {copy.call}
          </a>
        </div>
      </div>
    </div>
  )
}

export default PlanContactModal





